export default __webpack_public_path__ + "static/media/151-fader.d1abed43.png";